@if (customReportContent) {
  <ng-container *ngComponentOutlet="customReportContent" />
} @else {
  <cfp-building-report-content
    [buildingReportId]="building()?.buildingReport?.id"
    [buildingId]="buildingId()"
    [portfolioId]="portfolioId()"
    [buildingPublicSharedId]="buildingPublicSharedId"
    [hasBuildingReportLicense]="hasBuildingReportLicense()"
    [hasRoadmapLicense]="hasRoadmapLicense()"
    [reportCoverTitle]="reportCoverTitle"
    [reportCoverCompany]="reportCoverCompany"
    [showLabelInSummary]="showLabelInSummary()"
    [showDescriptionInSummary]="showDescriptionInSummary()"
    [showObjectTypeInSummary]="showObjectTypeInSummary()"
    [showSubObjectTypeInSummary]="showSubObjectTypeInSummary()"
    [showEnergyUsageInBusinessCase]="showEnergyUsageInBusinessCase()"
    [showOnlyExplanationForVisibleMeasures]="showOnlyExplanationForVisibleMeasures()"
    [isPdfServiceRequest]="isPdfServiceRequest()"
  >
    <ng-container headerRight>
      <ng-content select="[headerRight]" />
    </ng-container>
    <ng-container summaryBottom>
      <ng-content select="[summaryBottom]" />
    </ng-container>
    <ng-container measuresTop>
      <ng-content select="[measuresTop]" />
    </ng-container>
    <ng-container measuresBottom>
      <ng-content select="[measuresBottom]" />
    </ng-container>
    @if ((hasBuildingReportLicenseAndModify() || hasOldBuildingReportLicenseAndModify()) && building()) {
      <cfp-building-report-properties
        class="d-print-none"
        [buildingId]="buildingId()"
        [buildingReportId]="building()?.buildingReport?.id"
      />
    }
    <ng-container belowFooter>
      <ng-content select="[belowFooter]" />
    </ng-container>
  </cfp-building-report-content>
}
